export default "__VITE_ASSET__4pX7NljH__"